import { useEffect } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Products from "../components/Products";
import OfferLadder from "../components/OfferLadder";
import WelcomeBanner from "../components/WelcomeBanner";
import useSeo from "../lib/useSeo";

export default function Shop() {
  useSeo({
    title: "Plate Buddies Kits — plug-and-play family mealtime boxes",
    description:
      "Prefer to unbox than build? The Plate Buddies Starter Kit and Premium Meal Planning System are ready-to-go family mealtime experiences — no designing required. Free US shipping over $50.",
    url: "https://platebuddies.com/shop",
  });
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // /shop intentionally does NOT render <UrgencyBanner /> — its "SHOP KITS →"
  // CTA is a no-op here, and stacking it above <WelcomeBanner /> (which owns
  // the same WELCOME10 code but adds click-to-copy) reads as duplicate promo
  // spam. WelcomeBanner alone stays contextual and actionable.
  return (
    <div data-testid="page-shop" className="font-body text-pb-ink overflow-x-hidden">
      <Navbar />
      <WelcomeBanner />
      {/* Brand-sheet "one clear ladder": Free → $5 printable → $14.99 keepsake.
          Appears above the kits so parents see the simple decision tree first;
          kits remain standalone below for the "unbox, don't build" audience. */}
      <OfferLadder />
      <Products />
      <Footer />
    </div>
  );
}
